import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import Swal from "sweetalert2";

const RegistrationFields = (props) => {
    const history = useHistory();
    const [selectAll, setSelectAll] = useState(false);
    const [userType, setUserType] = useState(props.signedInUser.projectType);
    const [signUpFields, setSignUpFields] = useState(userType === "progress" ? {
        fullName: true,
        email: true,
        region: false,
        department: false
    } : {
        fullName: true,
        email: true,
        dateOfBirth: false,
        cgpa: false,
        city: false,
        degree: false,
        institute: false
    });

    
    const [assessmentInfo, setAssesssmentInfo] = useState({assessmentName: "error", assessmentFor: "error"});

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.userData.eventData?.assessmentName && props.userData.eventData?.assessmentFor) {
            setAssesssmentInfo({
                assessmentName: props.userData.eventData?.assessmentName,
                assessmentFor: props.userData.eventData?.assessmentFor
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Event Lost',
                text: 'Kindly Create Event Again',
                confirmButtonText: 'Proceed',
                allowOutsideClick: false
            }).then(result => {
                if (result.isConfirmed) {

                    history.push("/assessment/info");
                }
            })
        }
        if (props.userData.eventData?.registrationFields) {
            let initialFields = { ...signUpFields };
            props.userData.eventData?.registrationFields.forEach((_item) => {
                initialFields[_item] = true;
            });
           
            
            const allFieldsSelected = Object.keys(initialFields).every((field) =>
                field === 'selectAll' || initialFields[field]
            );
            setSelectAll(allFieldsSelected);
            setSignUpFields(initialFields);
        }
    }, [])

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
    
        if (name === 'selectAll') {
            setSelectAll(checked);
            setSignUpFields((userType === "progress" ? {
                            fullName: true,
                            email: true,
                            region: checked,
                            department: checked
                        } : {
                            fullName: true,
                            email: true,
                            dateOfBirth: checked,
                            cgpa: checked,
                            city: checked,
                            degree: checked,
                            institute: checked
                        }));
        } else {
            setSignUpFields((prevState) => ({
                ...prevState,
                [name]: checked,
            }));
    
            const allFieldsSelected = Object.keys(signUpFields).every((field) =>
         
                field === 'selectAll' || (field === name ? checked : signUpFields[field])
            );
            console.log(signUpFields);
            console.log(allFieldsSelected);
            setSelectAll(allFieldsSelected);
        }
    };

    

    const handleSubmit = () => {

        let fields = [];
        for (const item in signUpFields) {

            if (signUpFields[item]) {
                fields.push(item);
            }
        }

        props.setUserData({
            ...props.userData,
            eventData: {...props.userData.eventData, registrationFields: fields}
        });
        history.push("/assessment/loginMethod");
    }

    const previous = () => {
        history.goBack();
    }

    return (
        <Container className="ml-0 right-content-container">
            <Row className="">
                <Col>
                    <h1 className="">Your <span
                        className="active-text-color text-capitalize">{assessmentInfo.assessmentName} </span>
                        For <span className="warning-text-color text-capitalize">{assessmentInfo.assessmentFor}</span>
                    </h1>
                    <hr className="mb-0 mt-1 heading-hr mx-2"/>
                </Col>
            </Row>
            <div>
                <h2 className="active-text-color">Registration Game Fields</h2>
                <div className="">
                    <div>
                        <span className="fs-14">Select fields that candidate should enter before playing game</span>
                        <div className="inner-assessment-content">
                            <div style={{padding: "20px 0"}}>
                                <div className="mb-3">
                                    <input
                                        className="auth-checkbox mx-2"
                                        type="checkbox"
                                        id="selectAll"
                                        name="selectAll"
                                        checked={selectAll}
                                        onChange={handleCheckboxChange}
                                    />
                                    <label className='radio-label' htmlFor="selectAll">Mark All
                                        Fields</label>
                                </div>
                                <Row className="mb-3">
                                    <Col sm={3}>
                                        <div>
                                            <input
                                                className="auth-checkbox mx-2"
                                                type="checkbox"
                                                id="fullName"
                                                name="fullName"
                                                checked={signUpFields.fullName}
                                                readOnly={true}
                                                // onChange={handleCheckboxChange}
                                            />
                                            <label className='radio-label' htmlFor="fullName">Full
                                                Name</label>
                                        </div>
                                    </Col>
                                    <Col sm={3}>
                                        <div>
                                            <input
                                                className="auth-checkbox mx-2"
                                                type="checkbox"
                                                id="email"
                                                name="email"
                                                checked={signUpFields.email}
                                                readOnly={true}
                                                // onChange={handleCheckboxChange}
                                            />
                                            <label className='radio-label' htmlFor="email">Email
                                                Address</label>
                                        </div>
                                    </Col>
                                    {userType === "progress" ?
                                        <>
                                            <Col sm={3}>
                                                <div>
                                                    <input
                                                        className="auth-checkbox mx-2"
                                                        type="checkbox"
                                                        id="department"
                                                        name="department"
                                                        checked={signUpFields.department}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className='radio-label' htmlFor="department">Department</label>
                                                </div>
                                            </Col>
                                            <Col sm={3}>
                                                <div>
                                                    <input
                                                        className="auth-checkbox mx-2"
                                                        type="checkbox"
                                                        id="region"
                                                        name="region"
                                                        checked={signUpFields.region}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className='radio-label' htmlFor="region">Region</label>
                                                </div>
                                            </Col>
                                        </> :
                                        <>
                                            <Col sm={3}>
                                                <div>
                                                    <input
                                                        className="auth-checkbox mx-2"
                                                        type="checkbox"
                                                        id="city"
                                                        name="city"
                                                        checked={signUpFields.city}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className='radio-label' htmlFor="city">City</label>
                                                </div>
                                                {/*<div>*/}
                                                {/*    <input*/}
                                                {/*        className="auth-checkbox mx-2"*/}
                                                {/*        type="checkbox"*/}
                                                {/*        id="dateOfBirth"*/}
                                                {/*        name="dateOfBirth"*/}
                                                {/*        checked={signUpFields.dateOfBirth}*/}
                                                {/*        onChange={handleCheckboxChange}*/}
                                                {/*    />*/}
                                                {/*    <label className='radio-label' htmlFor="dateOfBirth">Date of*/}
                                                {/*        Birth</label>*/}
                                                {/*</div>*/}
                                            </Col>
                                            <Col sm={3}>
                                                <div>
                                                    <input
                                                        className="auth-checkbox mx-2"
                                                        type="checkbox"
                                                        id="cgpa"
                                                        name="cgpa"
                                                        checked={signUpFields.cgpa}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className='radio-label' htmlFor="cgpa">CGPA</label>
                                                </div>
                                            </Col>
                                        </>
                                    }
                                </Row>
                                {userType !== "progress" &&
                                    <Row>
                                        <Col sm={3}>
                                            <div>
                                                <input
                                                    className="auth-checkbox mx-2"
                                                    type="checkbox"
                                                    id="degree"
                                                    name="degree"
                                                    checked={signUpFields.degree}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className='radio-label' htmlFor="degree">Degree</label>
                                            </div>
                                        </Col>
                                        <Col sm={3}>
                                            <div>
                                                <input
                                                    className="auth-checkbox mx-2"
                                                    type="checkbox"
                                                    id="institute"
                                                    name="institute"
                                                    checked={signUpFields.institute}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className='radio-label' htmlFor="institute">Institute</label>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </div>
                    </div>
                    <Row className="buttons-div">
                        <Col sm={12} xs={12} md={6} lg={8}></Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="previous-button text-white w-100" onClick={previous}
                                    color="">Previous</Button>
                        </Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                    onClick={handleSubmit}
                                    color="">Next</Button>
                        </Col>
                    </Row>
                    {/*<div className="buttons-div">*/}
                    {/*    <div className="d-flex align-items-center" role="button">*/}
                    {/*        <img src={demoButton} alt="" height={17}/>*/}
                    {/*        <span className="text-dark font-weight-600 mx-2">Previous</span>*/}
                    {/*    </div>*/}
                    {/*    <div className="btn-vr"/>*/}
                    {/*    <div className="d-flex align-items-center" role="button" onClick={submitForm}>*/}
                    {/*        <span className="font-weight-600 mx-2 active-text-color">Next</span>*/}
                    {/*        <img src={nextBUtton} alt="" height={17}/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </Container>
    );
};

export default RegistrationFields;